import type { OrgOrderFilters } from './savedFilters';

export const buildExportParams = (
  filters: Omit<OrgOrderFilters, 'pageSize'> & {
    sortBy?: string | null;
    sortDirection?: 'asc' | 'desc';
  }
) => ({
  status: filters.status?.join(',') || undefined,

  search: filters.search.trim() || undefined,

  productId: filters.productId?.join(',') || undefined,
  locationId: filters.locationId?.join(',') || undefined,

  deliveryState: filters.deliveryState?.join(',') || undefined,
  pickupState: filters.pickupState?.join(',') || undefined,
  pickupCity: filters.pickupCity?.join(',') || undefined,

  truckNumber: filters.truckNumber?.join(',') || undefined,
  driverName: filters.driverName?.join(',') || undefined,

  carrierId: filters.carrierId?.join(',') || undefined,
  loadOption: filters.loadOption?.join(',') || undefined,

  tag: filters.tag?.join(',') || undefined,

  orderDateFrom: filters.orderDateFrom || undefined,
  orderDateTo: filters.orderDateTo || undefined,

  pickupDateFrom: filters.pickupDateFrom || undefined,
  pickupDateTo: filters.pickupDateTo || undefined,

  deliveryDateFrom: filters.deliveryDateFrom || undefined,
  deliveryDateTo: filters.deliveryDateTo || undefined,

  sortBy: filters.sortBy || undefined,
  sortDir: filters.sortDirection,

  salesRep: filters.salesRep?.join(',') || undefined,
});

export const flattenExportRows = (items: any[]): any[] =>
  (items || []).map((item: any) => ({
    ...item,
    orderCreatedAt: item.orderCreatedAt ?? item.order?.createdAt,
  }));
